/* eslint import/prefer-default-export: 0  */

export const section = {
  section: 'Section',
  pvqSection: 'Module',
  back: 'Back',
  next: 'Next',
};
